import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import StudentProgressReport from "ProgressReportDetails/routes/StudentProgressReport";
import Insights from "ProgressReportDetails/routes/Insights";
export default store => ({
  path: "student-view",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-progressreport" */ "./components"),
        import(
          /* webpackChunkName: "course-progressreport" */ "ProgressReport/modules/ProgressReportModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "progressReport",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Insights(store), StudentProgressReport(store)],
});
